// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require("path");

// ����Ŀ�������ַ������ʱ���л�Ϊ https://service.linkda.com.cn��
// const PROXY_TARGET = "https://service.linkda.com.cn";
// const PROXY_TARGET = "https://support.linkda.com.cn:8120";

module.exports = {
  dev: {
    // Paths
    assetsSubDirectory: "static",
    assetsPublicPath: "/",
    proxyTable: {
      // "/gys_users_req": {
      //   target: `${PROXY_TARGET}/gys_users_req`,
      //   pathRewrite: { "^/gys_users_req": "" },
      //   secure: false
      // },
      // "/uploadFile": {
      //   target: `${PROXY_TARGET}/uploadFile`,
      //   pathRewrite: { "^/uploadFile": "" },
      //   secure: false
      // },
      // "/file": {
      //   target: `${PROXY_TARGET}/file`,
      //   pathRewrite: { "^/file": "" },
      //   secure: false
      // }
    },
    get isAliServer () {
      return JSON.stringify(this.proxyTable) === "{}";
    },
    // Various Dev Server settings
    host: "localhost", // can be overwritten by process.env.HOST
    port: 8082, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    /**
     *
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: "cheap-module-eval-source-map",

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, "../SCM/index.html"),

    // Paths
    assetsRoot: path.resolve(__dirname, "../SCM"),
    assetsSubDirectory: "static",
    assetsPublicPath: "./",

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: "#source-map",

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ["js", "css"],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1